import styled from 'styled-components';

export const StyledP = styled.p`
  line-height: 20px;

  &:not(:first-child) {
    margin-top: ${(p) => p.theme.space[3]};
  }
`;
